"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.isNonEmptyString = function (str) {
  return str.length > 0;
}; // https://github.com/gcanti/fp-ts/blob/15f4f701ed2ba6b0d306ba7b8ca9bede223b8155/src/function.ts#L127


exports.flipCurried = function (fn) {
  return function (b) {
    return function (a) {
      return fn(a)(b);
    };
  };
};